import { SUBSCRIPTION_STATUS } from '../services/userService';

/**
 * Get the appropriate badge variant for a subscription status
 * @param {string} status - Subscription status
 * @returns {string} Bootstrap badge variant
 */
export const getStatusBadgeVariant = (status) => {
  switch (status) {
    case SUBSCRIPTION_STATUS.ACTIVE:
      return 'success';
    case SUBSCRIPTION_STATUS.TRIALING:
      return 'info';
    case SUBSCRIPTION_STATUS.PAST_DUE:
      return 'warning';
    case SUBSCRIPTION_STATUS.CANCELED:
      return 'danger';
    case SUBSCRIPTION_STATUS.INCOMPLETE:
      return 'secondary';
    default:
      return 'light';
  }
};

/**
 * Check if a subscription status is considered active
 * @param {string} status - Subscription status
 * @returns {boolean} True if status is active or trialing
 */
export const isActiveSubscription = (status) => {
  return status === SUBSCRIPTION_STATUS.ACTIVE || status === SUBSCRIPTION_STATUS.TRIALING;
};
